import { LegalLayout } from '@/components/LegalLayout';
import { useLanguage } from '@/lib/i18n/LanguageContext';

export default function AMLPage() {
  const { lang } = useLanguage();

  if (lang === 'tr') return (
    <LegalLayout title="AML/KYC Politikası" lastUpdated="24 Şubat 2026">
      <p>Safe Crypto, kara para aklama (AML) ve terörizmin finansmanının önlenmesi (CFT) konularında uluslararası standartlara ve Türkiye Cumhuriyeti mevzuatına tam uyum sağlamayı taahhüt eder.</p>

      <h2>1. Yasal Çerçeve</h2>
      <p>Politikamız aşağıdaki düzenlemelere dayanmaktadır:</p>
      <ul>
        <li>5549 sayılı Suç Gelirlerinin Aklanmasının Önlenmesi Hakkında Kanun</li>
        <li>MASAK (Mali Suçları Araştırma Kurulu) düzenlemeleri</li>
        <li>FATF (Financial Action Task Force) tavsiyeleri</li>
        <li>AB 5. Anti-Money Laundering Directive (5AMLD)</li>
      </ul>

      <h2>2. Müşteri Tanıma (KYC) Prosedürleri</h2>
      <h3>Seviye 1 - Temel Doğrulama</h3>
      <ul>
        <li>E-posta doğrulaması</li>
        <li>Telefon numarası doğrulaması</li>
        <li>Temel kimlik bilgileri (ad, soyad, doğum tarihi)</li>
      </ul>
      <h3>Seviye 2 - Gelişmiş Doğrulama</h3>
      <ul>
        <li>Resmi kimlik belgesi (nüfus cüzdanı, pasaport veya ehliyet)</li>
        <li>Selfie doğrulaması (canlı fotoğraf)</li>
        <li>Adres doğrulaması (fatura, banka ekstresi)</li>
      </ul>
      <h3>Seviye 3 - Artırılmış İnceleme (EDD)</h3>
      <ul>
        <li>Yüksek riskli müşteriler ve siyasi nüfuz sahibi kişiler (PEP) için</li>
        <li>Fon kaynağı belgesi</li>
        <li>Ek kimlik doğrulama süreçleri</li>
      </ul>

      <h2>3. İşlem İzleme</h2>
      <ul>
        <li>Tüm işlemler gerçek zamanlı olarak izlenir</li>
        <li>Şüpheli işlem kalıpları otomatik olarak tespit edilir</li>
        <li>Belirli eşik değerleri üzerindeki işlemler manuel incelemeye alınır</li>
        <li>Yapısal işlem bölme (structuring) girişimleri tespit edilir</li>
      </ul>

      <h2>4. Şüpheli İşlem Bildirimi</h2>
      <p>Şüpheli bulunan işlemler, yasal yükümlülüklerimiz gereği MASAK'a bildirilir. Kullanıcıya bu bildirim hakkında bilgi verilmez (tipping-off yasağı).</p>

      <h2>5. Yaptırım Taraması</h2>
      <ul>
        <li>BM, AB, OFAC ve Türkiye yaptırım listeleri düzenli olarak kontrol edilir</li>
        <li>Yaptırım listesindeki kişi ve kuruluşlarla işlem yapılmaz</li>
        <li>Yüksek riskli ülkelere özel dikkat gösterilir</li>
      </ul>

      <h2>6. Kayıt Tutma</h2>
      <p>Tüm müşteri bilgileri ve işlem kayıtları, yasal gerekliliklere uygun olarak en az 10 yıl süreyle saklanır.</p>

      <h2>7. Uyumsuzluk</h2>
      <p>AML/KYC politikalarına uymayan hesaplar askıya alınabilir, kapatılabilir ve ilgili makamlara bildirilebilir.</p>
    </LegalLayout>
  );

  return (
    <LegalLayout title="AML/KYC Policy" lastUpdated="February 24, 2026">
      <p>Safe Crypto is committed to full compliance with international standards and Republic of Turkey legislation on Anti-Money Laundering (AML) and Combating the Financing of Terrorism (CFT).</p>

      <h2>1. Legal Framework</h2>
      <ul>
        <li>Turkish Law No. 5549 on Prevention of Laundering Proceeds of Crime</li>
        <li>MASAK (Financial Crimes Investigation Board) regulations</li>
        <li>FATF (Financial Action Task Force) recommendations</li>
        <li>EU 5th Anti-Money Laundering Directive (5AMLD)</li>
      </ul>

      <h2>2. Know Your Customer (KYC) Procedures</h2>
      <h3>Level 1 - Basic Verification</h3>
      <ul><li>Email verification</li><li>Phone number verification</li><li>Basic identity information</li></ul>
      <h3>Level 2 - Enhanced Verification</h3>
      <ul><li>Official ID document</li><li>Selfie verification</li><li>Address verification</li></ul>
      <h3>Level 3 - Enhanced Due Diligence (EDD)</h3>
      <ul><li>For high-risk customers and PEPs</li><li>Source of funds documentation</li><li>Additional verification processes</li></ul>

      <h2>3. Transaction Monitoring</h2>
      <ul>
        <li>All transactions are monitored in real-time</li>
        <li>Suspicious transaction patterns are automatically detected</li>
        <li>Transactions above certain thresholds are manually reviewed</li>
      </ul>

      <h2>4. Suspicious Activity Reports</h2>
      <p>Suspicious transactions are reported to MASAK as required by law. Users are not informed about these reports (tipping-off prohibition).</p>

      <h2>5. Sanctions Screening</h2>
      <ul>
        <li>UN, EU, OFAC and Turkey sanctions lists are regularly checked</li>
        <li>No transactions with sanctioned persons or entities</li>
      </ul>

      <h2>6. Record Keeping</h2>
      <p>All customer information and transaction records are retained for at least 10 years in accordance with legal requirements.</p>
    </LegalLayout>
  );
}
